import React from 'react'
import {Select} from "antd"

const {Option} = Select

const SelectSearchDouble = (props) => {
    const {listSelect, name, value, label} = props

    const _handleChangeSelect = (value) => {
        props.onChange(name, value)
    }

    return (
        <div className="InputSearch">
            <label htmlFor={name}>{label}</label>

            <Select
                id={name}
                style={{width: '100%'}}
                defaultValue=""
                value={value}
                onChange={_handleChangeSelect}
                showSearch
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                optionFilterProp="children"
                placeholder="Please select"
            >
                {
                    listSelect.map(item => {
                        return <Option value={item.value} key={item.value}>{item.name}</Option>
                    })
                }
            </Select>
        </div>
    )
}

export default SelectSearchDouble
